'use client'

// Import Components
import Auth from '@/components/Auth/Auth'
import { TimedOutContent } from '@/components/SessionTimeout/SessionTimeout'

const Login = () => {
    return (
        <>
            <Auth type={'login'} />
            <TimedOutContent />
        </>
    )
}

export default Login
